function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiamond(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82DCC7"
    },
    points: "255.999,450.013 0,191.905 97.783,61.992 414.217,61.992 512,191.905  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#82DCC7"
    },
    points: "511.999,191.909 255.999,450.013 389.005,191.909  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95E5D0"
    },
    points: "255.999,191.909 255.999,450.013 389.005,191.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#95E5D0"
    },
    points: "97.783,61.987 122.994,191.909 0,191.909  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5EAD6"
    },
    points: "122.994,191.909 255.999,191.909 255.999,61.987 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#74CBB4"
    },
    points: "414.216,61.987 511.999,191.909 389.005,191.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#74CBB4"
    },
    points: "122.994,191.909 255.999,450.013 255.999,191.909  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#74CBB4"
    },
    points: "255.999,61.987 122.994,191.909 97.783,61.987  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#A5EAD6"
    },
    points: "255.999,61.987 389.005,191.909 414.216,61.987 "
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiamond);
export default __webpack_public_path__ + "static/media/diamond.3a0c8f7e2b932fa5f4b072bd9e0b8bfa.svg";
export { ForwardRef as ReactComponent };